import React, { useState, FC, ReactNode, useEffect, useCallback } from 'react';
import { VendorContext } from './context';
import { DefaultvendorFormData } from 'pages/main-store/vendors/add-vendor';
import { ActiveType, VendorFormType, VendorType } from 'models/vendors.model';
import { handleApiError } from 'utils/functions';
import { apiService } from 'services/base.service';
import { BankType } from 'models/bank.model';

export const DefaultVendorToEdit = {
  account_name: '',
  account_number: '',
  address: '',
  archived: false,
  bank_name: '',
  created_at: '',
  id: '',
  name: '',
  outstanding: '',
  phone_number: '',
  total_paid: '',
  updated_at: '',
  payment_period: '',
  items: []
};
const VendorProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [vendorFormData, setVendorFormData] = useState<VendorFormType[]>([DefaultvendorFormData]);
  const [vendorToEdit, setVendorToEdit] = useState<VendorType>(DefaultVendorToEdit);
  const [active, setActive] = useState<ActiveType | null>(null);
  const [activeVendorProfile, setActiveVendorProfile] = useState<VendorType>(DefaultVendorToEdit);
  const [step, setStep] = useState(1);
  const [bankList, setBankList] = useState<BankType[]>([]);
  const fetchedPagesRef = React.useRef<Set<number>>(new Set());

  const fetchBankList = async (page: number) => {
    if (fetchedPagesRef.current.has(page)) return 30;

    try {
      const response = await apiService.get(`internal/banks?page=${page}`, {
        isInternal: true,
        version: 'v2'
      });

      fetchedPagesRef.current.add(page);

      setBankList((prev) => [...prev, ...response.data.data]);

      return response.data.data.length;
    } catch (error) {
      handleApiError(error);
    }
  };

  const fetchAllBanks = useCallback(async () => {
    let page = 1;
    let resultsLength = 30;

    while (resultsLength >= 30) {
      resultsLength = await fetchBankList(page);
      page += 1;
    }
  }, []);

  useEffect(() => {
    fetchAllBanks();
  }, []);

  return (
    <VendorContext.Provider
      value={{
        vendorFormData,
        setVendorFormData,
        vendorToEdit,
        setVendorToEdit,
        active,
        setActive,
        activeVendorProfile,
        setActiveVendorProfile,
        step,
        setStep,
        bankList
      }}>
      {children}
    </VendorContext.Provider>
  );
};

export default VendorProvider;
